"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MISSING_PROPERTY = exports.JSON_NOT_VALID = exports.JSON_NOT_PROVIDED = void 0;
var JSON_NOT_PROVIDED = exports.JSON_NOT_PROVIDED = 'No JSON string provided!';
var JSON_NOT_VALID = exports.JSON_NOT_VALID = "Provided JSON string is not valid JSON!";
var MISSING_PROPERTY = exports.MISSING_PROPERTY = 'Missing {0} config property!'; //# sourceMappingURL=constants.js.map
